import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Divider } from './components/Divider';
import { Upsell } from './components/Upsell';
import { About } from './components/About';
import { Testimonials } from './components/Testimonials';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-lavender font-sans text-ink selection:bg-accent-light selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Divider data-id="element-4" />
        <Upsell data-id="element-5" />
        <About data-id="element-6" />
        <Testimonials data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}